import { gql } from '@apollo/client'

// CARE_PLAN_DRAFT_DETAILS

export default gql`
  query care_plan_draft_details($id: ID!) {
    roadmap_v2(id: $id) {
      id
      title
      request_notes
      description
      preferred_address
      preferred_distance
      special_needs
      performed_by
      introduction
      member {
        id
        first_name
        last_name
      }
      tickets {
        id
      }
      suggested_doctors {
        navigator_notes
        contact_uuid
        cost {
          user_pays
        }
        profile {
          id
          npi_id
          first_name
          last_name
          full_name
          image_url
          specialty_names
          rating
          contacts {
            address
            phone
          }
          addresses(min_confidence: 0) {
            address
            phone
            uuid
            zip
            confidence
            latitude
            longitude
            distance
            rightway_primary
          }
        }
        insurance_tier {
          id
          name
          insurance_plan {
            id
            display_name
            carrier_display_name
          }
        }
      }
      suggested_facilities {
        navigator_notes
        cost {
          user_pays
        }
        profile {
          id
          uuid
          name
          latitude
          longitude
          google_maps_link
          image_url
          location_types
          display_location_types
          contacts {
            address
            phones
          }
        }
        insurance_tier {
          id
          name
          insurance_plan {
            id
            display_name
          }
        }
      }
    }
  }
`
